import * as types from "./types";

function obtenerListaColegiosConEscuelas(payload) {
  return { type: types.OBTENER_COLEGIOS_ESCUELAS_VACACIONES, payload };
}

function limpiarListaColegioEscuelas() {
  return { type: types.LIMPIAR_COLEGIOS_ESCUELAS_VACACIONES };
}

function eliminarColegioListaEscuelas(payload) {
  return { type: types.ELIMINAR_COLEGIO_LISTA_ESCUELAS_VACACIONES, payload };
}

function escuelasSinComedor(payload) {
  return { type: types.ESCUELAS_SIN_COMEDOR, payload };
}

function escuelasConComedor(payload) {
  return { type: types.ESCUELAS_CON_COMEDOR, payload };
}

function limpiarEscuelasConComedor() {
  return { type: types.LIMPIAR_ESCUELAS_CON_COMEDOR };
}
function limpiarEscuelasSinComedor() {
  return { type: types.LIMPIAR_ESCUELAS_SIN_COMEDOR };
}

/*---*/
export {
  obtenerListaColegiosConEscuelas,
  limpiarListaColegioEscuelas,
  eliminarColegioListaEscuelas,
  escuelasSinComedor,
  escuelasConComedor,
  limpiarEscuelasConComedor,
  limpiarEscuelasSinComedor
};



// WEBPACK FOOTER //
// ./src/ducks/escuelas/actions.js